export default __webpack_public_path__ + "f2782c3963b1fffcf692efde49932169.png";